// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1QsoA","resendInfoText":"OnGoingPaymentBox_resendInfoText__2S1I0"};